// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 284) return "assets/js/vue/pages/sponsor/sponsor/284.js";
	if (chunkId === 558) return "assets/js/vue/pages/sponsor/sponsor/558.js";
	// return url for filenames based on template
	return undefined;
};